<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 module-title">PRODUCTIE INFO</div>
      <div class="col-lg-12" v-if="!barcode && !item && !error">
        <div class="product-info">
          Scan een barcode om productie informatie weer te geven.
        </div>
      </div>
      <div class="col-lg-12" v-if="debug">
        <div class="product-info error">
          {{debug}}
        </div>
      </div>
      <div class="col-lg-12" v-if="barcode && !item && !error">
        <div class="product-info">
          <span class="item-loader float-left"></span> Ophalen informatie {{barcode}}...
        </div>
      </div>
      <div class="col-lg-12" v-if="barcode && item && !error">
        <div class="product-info">
          <table>
            <tr>
              <th>Status</th>
              <td v-html="getProductionStatusBadge(item)"></td>
            </tr>
            <tr>
              <th>Productiebon</th>
              <td v-html="item.productionReceipt ? getPrintStatusBadge(item.productionReceipt.printStatus) : ''"></td>
            </tr>
            <tr>
              <th>Pakbon</th>
              <td v-html="item.packingSlip ? getPrintStatusBadge(item.packingSlip.printStatus) : ''"></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th>Barcode</th>
              <td>{{barcode}}</td>
            </tr>
            <tr>
              <th>Product</th>
              <td>{{item.product.productName}}</td>
            </tr>
            <tr>
              <th>Variant</th>
              <td>{{item.variation.variationName}}</td>
            </tr>
            <tr>
              <th>Productie datum</th>
              <td>{{item.productionDate}}</td>
            </tr>
            <tr>
              <th>Aflever datum</th>
              <td>{{item.deliveryDate}}</td>
            </tr>
            <tr>
              <th>Opties</th>
              <td>
                <span v-if="item.logo">+ Logo<br /></span>
                <span v-if="item.attachments.length > 0">+ Brief<br /></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-lg-12" v-if="barcode && !item && error">
        <div class="product-info error">
          {{error}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EB from 'EB'

  const barcodeOptions = {
    allDecoders: false,
    code128: true,
    code128securityLevel: 0,
    code39: true,
    code39securityLevel: 0,
    datamatrix: true,
    aimType: EB.Barcode.AIMTYPE_TRIGGER, // AIMTYPE_CONTINUOUS_READ
    decodeFrequency: 2000,
    decodeLEDFeedback: true,
    decodeLEDFeedbackMode: EB.Barcode.LEDMODE_BOTH,
    decodeLEDTime: 300,
    decodeVolume: 5,
    decodeDuration: 200,
    hapticFeedback: true,
    lcdMode: true,
    sameSymbolTimeout: 3000,
    differentSymbolTimeout: 0
  }

  export default {
    created () {
      if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
        this.scannerType = 'zebra'
        this.initializeScanner()

        EB.Application.setApplicationNotify(this.onZebraApplicationDestroy)
      } else {
        this.scannerType = 'software'
      }
    },
    beforeDestroy () {
      if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
        if (this.scanner) {
          this.scanner.disable()
          this.scanner = null
        }
      }
    },
    data () {
      return {
        item: null,
        error: null,
        barcode: null,
        scannerType: null,
        debug: null,
        scanner: null
      }
    },
    computed: {
    },
    methods: {
      initializeScanner: function () {
        EB.Barcode.enumerate(scanners => {
          if (scanners.length === 0) {
            this.error = 'Geen barcode scanner gevonden'
            return
          }

          this.scanner = scanners[0]
          this.scanner.enable(barcodeOptions, this.zebraBarcodeScanned)
        })
      },
      onZebraApplicationDestroy: function (event) {
        switch (event.applicationEvent) {
          case EB.Application.APP_EVENT_ACTIVATED:
          case EB.Application.APP_EVENT_UICREATED:
          case EB.Application.APP_EVENT_SCREEN_ON:
            this.initializeScanner()
            console.log('activated scanner 2')
            break
          case EB.Application.APP_EVENT_SCREEN_OFF:
          case EB.Application.APP_EVENT_UIDESTROYED:
          case EB.Application.APP_EVENT_DEACTIVATED:
            console.log('disabled scanner 2')
            if (this.scanner) {
              this.scanner.disable()
              this.scanner = null
            }
            break
        }
      },
      zebraBarcodeScanned: function (barcode) {
        this.fetchProductInfo(barcode.data)
      },
      fetchProductInfo: function (barcode) {
        this.barcode = barcode
        this.item = null
        this.error = null

        this.$http.get(process.env.API_URL + '/production-receipt/' + barcode).then(response => {
          this.item = response.body
        }, response => {
          if (response.status === 0) {
            this.error = 'Kan geen informatie ophalen vanaf de server, controleer de internetverbinding.'
          } else if (response.status === 404) {
            this.error = 'Geen informatie gevonden voor ' + barcode + '.'
          } else {
            this.error = 'Er heeft zich een onbekende fout voorgedaan voor ' + barcode + '.'
          }
          // do nothing
        })
      },
      getProductionStatusBadge: function (item) {
        switch (item.productionStatus) {
          case 'new':
            return '<span class="badge badge-production-status badge-new">Nieuw</span>'
          case 'cancelled':
            return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>'
          case 'preparing_for_production':
          case 'in_production':
            return '<span class="badge badge-production-status badge-in-production">In productie</span>'
          case 'produced':
            if (item.packingStatus === 'packed') {
              return '<span class="badge badge-production-status badge-packed">Ingepakt</span>'
            }

            return '<span class="badge badge-production-status badge-produced">Geproduceerd</span>'
          default:
            return item.productionStatus
        }
      },
      getPrintStatusBadge: function (status) {
        switch (status) {
          case 'unprinted':
            return '<span class="badge badge-production-status badge-unprinted">Niet geprint</span>'
          case 'preparing':
            return '<span class="badge badge-production-status badge-printing">Wordt geprint...</span>'
          case 'printed':
            return '<span class="badge badge-production-status badge-printed">Geprint</span>'
          default:
            return status
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a:hover {
    cursor: pointer;
  }

  .product-info {
    background-color: #fff;
    margin-top: 15px;
    padding: 10px;
    width: 100%;
  }

  .product-info table {
    width: 100%;
  }

  .product-info table td,
  .product-info table th {
    vertical-align: top;
  }

  .product-info.error {
    background-color: #dc3545;
    color: #fff;
  }

  .module-title {
    background-color: #17a2b8;
    color: #fff;
    font-size: 20px;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductionItemInfo.vue